import serviceSwitch from '@/request/common/switch';
import { ClientHostType } from '@/types';

export const switchConfig = (set, get) => {
  return {
    leaseConfig: null,
    fetchLeaseConfig: async (key: any, wapid, cinemaId) => {
      // 检查缓存数据是否已存在且与当前 key 匹配
      const currentData = get().filmData;
      if (currentData && currentData.key === key) {
        // 如果已存在且匹配，不需要重新获取数据
        return;
      }
      try {
        // 假设有一个函数 fetchDataFromAPI 来获取数据
        if (wapid && cinemaId && get().channel === ClientHostType.galaxy) {
          const { result } = await serviceSwitch.getleaseconfig();
          set({ leaseConfig: { key, value: result?.bizValue } });
        }
      } catch (error) {
        console.error('获取数据失败', error);
      } finally {
        // 无论成功还是失败，最后都将 loading 状态设置为 false
      }
    },
  };
};
